module.exports = __webpack_public_path__ + "static/media/desktop_640x480.a470a81c.png";